import {
  fetchCreateProofRequestStarted,
  fetchCreateProofRequestSuccess,
  fetchCreateProofRequestError,
} from "./index";

// Creates a presentation request
export const fetchCreateProofRequest = () => async (dispatch) => {
  // Request body
  const json = `{
    "proof_request": {
      "name": "Prova de credencial",
      "requested_attributes": {
        "identity": {
          "names": [
            "name",
            "email",
            "telefone",
            "cpf"
          ],
          "restrictions": [
            {
              "cred_def_id": "${process.env.REACT_APP_IDENTITY_CRED_DEF_ID}"
            }
          ]
        },
        "address": {
          "names": [
            "cep",
            "endereco",
            "estado",
            "cidade"
          ],
          "restrictions": [
            {
              "cred_def_id": "${process.env.REACT_APP_ADDRESS_CRED_DEF_ID}"
            }
          ]
        },
        "credit_card": {
          "names": [
            "numero_do_cartao",
            "nome_no_cartao",
            "data_de_validade",
            "cvv"
          ],
          "restrictions": [
            {
              "cred_def_id": "${process.env.REACT_APP_CREDIT_CARD_CRED_DEF_ID}"
            }
          ]
        }
      },
      "requested_predicates": {
        "additionalProp1": {
          "name": "data_de_nascimento",
          "p_type": "<=",
          "p_value": 20050101,
          "restrictions": [
            {
              "cred_def_id": "${process.env.REACT_APP_IDENTITY_CRED_DEF_ID}"
            }
          ]
        }
      },
      "version": "1.0"
    }
  }`;
  try {
    dispatch(fetchCreateProofRequestStarted());
    // POST request with set headers and body to create a present-proof request
    const response = await fetch(
      `${process.env.REACT_APP_VERIFIER_URL}/present-proof/create-request`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          apiKey: `${process.env.REACT_APP_VERIFIER_API_KEY}`,
          Authorization: `Bearer ${process.env.REACT_APP_VERIFIER_TOKEN}`,
        },
        body: json,
      }
    );
    // Gets the response of the POST request
    const data = await response.json();
    if (!response.ok) {
      throw data.error;
    }
    return dispatch(fetchCreateProofRequestSuccess(data));
  } catch (error) {
    return dispatch(fetchCreateProofRequestError(error.toString()));
  }
};
